var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-box"},[_c('h2',{staticClass:"msg-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.tips),function(item,index){return _c('ul',{key:index,staticClass:"msg"},[_c('li',{domProps:{"innerHTML":_vm._s(item)}})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e88306e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/lib/ui/default/message/src/content/showTips.vue
// module id = 1553
// module chunks = 2